/********************/
// Production Environment tokens
/********************/
const organizationId = "6dba0850-b218-42a7-b86d-0f740799cbb9";
const token = "5c870c80-aeab-4f88-99a3-58a7c1012b4b";

/********************/
// Preview Environment tokens
/********************/
//const organizationId = "32232a3a-84ba-4ff3-9458-6d5178aff142";
//const token = "c5f6120f-4edc-4563-ae94-6417a7e23df6";

function getThreekitDisplayAttributes(configurator) {
  // page load
  setThreeKitConfiguration(configurator);

  addEventListener("change", (event) => {
    setThreeKitConfiguration(configurator);
  });
}

async function setThreeKitConfiguration(configurator) {
  const URL = `https://admin-fts.threekit.com/api/datatables/${window.mapTableId}/rows?orgId=${organizationId}&bearer_token=${token}&all=true`;
  const dataTable = await fetchOptionsValue(URL);

  const setConfigurationItems = {};
  const productOptions = document.querySelectorAll('product-option-picker');
  productOptions.forEach((productOption) => {
    const configurationValue = productOption.querySelector('[data-option-value]').textContent;

    // Map shopifys value to the shopify_options_value and return the threekit_attr_value
    const optionValue = dataTable.rows.find((optionValue) => {
      return optionValue.value.shopify_options_value  === configurationValue;
    });

    if (configurationValue && optionValue) {
      setConfigurationItems[optionValue.value.threekit_attr_name] = optionValue.value.threekit_attr_value;
    }
  });

  const productOptionsRadios = document.querySelectorAll('.bold_options input:checked');
  productOptionsRadios.forEach((productOptionsRadio) => {
    const configurationValue = productOptionsRadio.value;
    const configurationName = productOptionsRadio.closest('.bold_option').querySelector('.bold_option_title').textContent;

    // Map shopifys value to the shopify_options_value and return the threekit_attr_value
    const optionValue = dataTable.rows.find((optionValue) => {
      return optionValue.value.shopify_options_value  === configurationValue;
    });

    if (configurationValue && optionValue && optionValue.value.shopify_options_name.indexOf(configurationName) > -1) {
      setConfigurationItems[optionValue.value.threekit_attr_name] = optionValue.value.threekit_attr_value;
    }
  })

  await configurator.setConfiguration(setConfigurationItems);
}

async function createThreekitImg() {
  if (!window.player) {
    return;
  }

  const cameraData = await window.player.scene.getAll({
    hierarchical: true,
  });

  const cameraObj = Object.values(cameraData);
  const cameraId = cameraObj.find((camera) => camera.type === "Camera");

  if (cameraId) {
    let imgSrc = await window.player.snapshotAsync({
      size: { width: 300, height: 300 },
      mimeType: "image/png",
      cameraId: cameraId.id,
    });

    return imgSrc;
  }
  return;
}

const fetchOptionsValue = async (URL) => {
  await fetch(URL, {
    method: "GET"
  })
    .then((res) => 
      res.json()
    )
    .then((res) => {
      dataTable = res;
      return dataTable;
    });
  return dataTable;
};